import { defineSlotRecipe } from '@chakra-ui/react';

// v2 parts container/button/panel → v3 slots item/itemTrigger/itemBody
const accordionSlotRecipe = defineSlotRecipe({
  slots: ['item', 'itemTrigger', 'itemBody'],
  base: {
    item: {
      borderTopWidth: '1px',
      borderColor: 'inherit',
      _last: {
        borderBottomWidth: '1px',
      },
    },
    itemTrigger: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 'sm',
      fontWeight: 'bold',
      color: 'blue.500',
      textAlign: 'left',
      textTransform: 'uppercase',
      letterSpacing: 'wide',
      borderRadius: 0,
      _expanded: {
        color: 'blue.900',
      },
      _focus: {
        boxShadow: 'insetOutline',
        outline: 'none',
      },
      _hover: {
        bg: 'blue.50',
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
      },
      px: 4,
      py: 2,
      height: 16,
    },
    itemBody: {
      pt: 2,
      px: 4,
      pb: 5,
    },
  },
});

export default accordionSlotRecipe;
